import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import {AppResourceCollection} from "@milestoneslabs/milestones-js-engine";
import WildAppResource from "../AppResources/WildAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";

export class StateAppResourceSearch extends AppResourceSearch {
    constructor(resourceType) {
        super(resourceType);
        this._allStatesAppResourceCollection = new AppResourceCollection(resourceType);
    }

    async search(listAll = false) {
        if (this._allStatesAppResourceCollection.isNotEmpty) {
            this.applyFilter(listAll);
            return;
        }

        const states = (await Engine.get(this.statesPath)).rawData.data;

        for (const [stateAbbreviation, stateName] of Object.entries(states)) {
            const stateAppResource = new WildAppResource({
                attributes: {
                    abbreviation: stateAbbreviation,
                    state: stateName,
                }
            });
            this._allStatesAppResourceCollection.addResource(stateAppResource);
        }

        this.applyFilter(listAll);
        return null;
    }

    get statesPath() {
        return Engine.apiHost + '/' + Engine.apiPrefix + '/location/' + Engine.apiVersion + '/states/us';
    }

    applyFilter(listAll = false) {
        if (!this.filter || !this.filter.params || !this.filter.params.state) {
            if (listAll) {
                this._appResourceCollection = this._allStatesAppResourceCollection.filter(appResource => {
                    return this.allStates.includes(appResource.state);
                });
                return;
            }

            this._appResourceCollection = this._allStatesAppResourceCollection.filter(appResource => {
                return this.allowedStates.includes(appResource.state);
            });
            return;
        }
        this._appResourceCollection = this._allStatesAppResourceCollection.filter(appResource => {
            return this.appResourcePropFilterCondition(appResource, 'state', listAll) ||
                this.appResourcePropFilterCondition(appResource, 'abbreviation', listAll);
        });
    }

    appResourcePropFilterCondition(appResource, prop, listAll = false) {
        if (listAll) {
            return appResource[prop].toLowerCase().includes(this.filter.params['state'].toLowerCase())
                && this.allStates.includes(appResource.state);
        }

        return appResource[prop].toLowerCase().includes(this.filter.params['state'].toLowerCase())
            && this.allowedStates.includes(appResource.state);
    }

    get allowedStates() {
        return [
            'Arizona',
            'California',
            'Colorado',
            'Florida',
            'Georgia',
            'Idaho',
            'Illinois',
            'Indiana',
            'Oregon',
            'Ohio',
            'Pennsylvania',
            'Louisiana',
            'Maryland',
            'Michigan',
            'Minnesota',
            'Mississippi',
            'Missouri',
            'Nevada',
            'New Jersey',
            'South Carolina',
            'North Carolina',
            'Tennessee',
            'Texas',
            'Washington',
            'Wisconsin',
        ];
    }

    get allStates() {
        return [
            'Alabama',
            'Alaska',
            'Arizona',
            'Arkansas',
            'California',
            'Colorado',
            'Connecticut',
            'Delaware',
            'District of Columbia',
            'Florida',
            'Georgia',
            'Hawaii',
            'Idaho',
            'Illinois',
            'Indiana',
            'Iowa',
            'Kansas',
            'Kentucky',
            'Louisiana',
            'Maine',
            'Maryland',
            'Massachusetts',
            'Michigan',
            'Minnesota',
            'Mississippi',
            'Missouri',
            'Montana',
            'Nebraska',
            'Nevada',
            'New Hampshire',
            'New Jersey',
            'New Mexico',
            'New York',
            'North Carolina',
            'North Dakota',
            'Ohio',
            'Oklahoma',
            'Oregon',
            'Pennsylvania',
            'Rhode Island',
            'South Carolina',
            'South Dakota',
            'Tennessee',
            'Texas',
            'Utah',
            'Vermont',
            'Virginia',
            'Washington',
            'West Virginia',
            'Wisconsin',
            'Wyoming',
        ];
    }
}
